import React from "react";
import {Close, LinkSharp, WhatsApp} from "@material-ui/icons";
import {Instagram, Phone, PhoneCall, Share2} from "react-feather";
import {Col, NavLink, Row} from "reactstrap";
import logo from "../../../assets/img/logo/logo.webp";
import {FaInstagram} from "react-icons/fa";
import {FaTelegramPlane} from "react-icons/fa";
import Technical from "../../../assets/img/logo/Technical professional.png";
import {FiPhoneCall, FiYoutube} from "react-icons/fi";
import {MdOutlineWhatsapp} from "react-icons/md";
import zarin from "../../../assets/img/elements/zarin.png"
import data from "../../../assets/data/configs/storeConfig.json"
import {connect} from "react-redux";
import RenderMedia from "../../media/renderMedia";
import {Link} from "react-router-dom";
import {history} from "../../../history";
import {BiSupport} from "react-icons/bi";
import footerImage from "../../../assets/img/elements/footerImage.webp";
import {isMobile} from "react-device-detect";
import PWAInstallGuide from "../pwaButton";


class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            whatsapp: false,
            enamad: true,
            quick_access: this.props.UI.menu ? this.props.UI.menu : [],
            latest_courses: this.props.UI.latest_courses ? this.props.UI.latest_courses : [],
            settings: this.props.UI.settings ? this.props.UI.settings : [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.props.UI !== prevProps.UI)) {
            this.setState({
                quick_access: this.props.UI.menu ? this.props.UI.menu : [],
                latest_courses: this.props.UI.latest_courses ? this.props.UI.latest_courses : [],
                settings: this.props.UI.settings ? this.props.UI.settings : [],
            })
        }
    }

    support = () => {
        this.setState({
            whatsapp: !this.state.whatsapp,
        })
    }
    handleSupport = (targetPath) => {
        if (targetPath) history.push(targetPath)
        this.setState({
            support: !this.state.support,
        })
    }

    render() {
        return (
            <>
                <div className="web-footer">
                 {/*   <div className='web-footer-top m-auto rounded d-flex align-items-center justify-content-around p-4'>
                        <div>
                            <span className='h2 text-white'>جهت کسب اطلاعات بیشتر با ما در تماس باشید.</span>
                        </div>
                        <div>
                            <a href={`tel:${data.mobile[0]}`}>
                                <button className="btn">
                                    <FiPhoneCall/>
                                    {data.mobile[0]}
                                </button>
                            </a>
                        </div>
                    </div>*/}
                    <div className="bg-black-footer ">
                        <Row>
                            <Col md={4} sm={12}>
                                <div className='footer-logo'>

                                    <h4>{data.footerName}</h4>
                                </div>
                                <div className='footer-desc'>
                                    <p dangerouslySetInnerHTML={{__html:this.state?.settings?.short_about_us}}/>
                                </div>
                                <div>
                                    <PWAInstallGuide/>
                                </div>

                            </Col>
                            <Col md={8} sm={12}>
                                <Row>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>لینک دسترسی سریع</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                this.state.quick_access?.filter(item => item?.parentId === "main")?.map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        {item.type === 1 && <Link to={item.url}>{item.title}</Link>}
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>دوره ها</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                this.state.latest_courses?.slice(0, 5)?.map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        <Link
                                                            to={`/course/${item.slug}`}> {item.name} </Link>
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>تماس با ما</h5>

                                        <div className='footer-location'>
                                            <span>ساعات پاسخگویی: </span>
                                            {data?.workingHours?.map(item => {
                                                return <p className={"text-justify"}>{item}</p>
                                            } )}
                                        </div>

                                        {
                                            data?.address?.length > 0 && <div className='footer-location'>
                                                <span>آدرس: </span>
                                                {data?.address?.map(item => {
                                                    return <p className={"text-justify"}>{item}</p>
                                                } )}
                                            </div>
                                        }


                                        <div className='footer-phone'>
                                            <span>تلفن: </span>
                                            {data.mobile?.map(item => (
                                                <a href={`tel:${item?.value}`}>
                                                    <Phone/> {item?.label}: {item?.value}
                                                </a>
                                            ))}
                                        </div>
                                        <div className='footer-social'>
                                            {
                                                <RenderMedia/>
                                            }
                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <div>
                                            <div className='footer-item-nemad mt-1'>
                                                <div className={` nemad-box ${!data.enamadLink && "opacity-0"}`}>
                                                    <a referrerPolicy='origin' target='_blank'
                                                       className=''
                                                       href={data.enamadLink}><img
                                                        referrerPolicy='origin'
                                                        src={data.enamadImageLink}
                                                        alt='' style={{cursor: 'pointer'}} Code={data.enamadCode}/></a>
                                                </div>

                                                <div className=' nemad-box '>
                                                    <a href={"https://www.zarinpal.com/trustPage/maedehacademy.com"}
                                                          target='_blank'>
                                                        <img src={zarin}/>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='footer-item-nemad mt-1'>
                                            <div className=' nemad-box d-flex'>
                                                <iframe
                                                    src={data.ifeameLink}
                                                    width={'100%'} height={"150"} style={{"border":0 , borderRadius:"10px"}} allowFullScreen="" loading="lazy"
                                                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                                            </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </div>

                    <div className='border-footer'></div>

                    <div className="copyright p-1 w-100 m-auto">
                        <p className="m-0">
                            {'کلیه حق و حقوق وبسایت برای '}
                            <a href={data.url}>
                                <strong className='text-bold'>
                                    {data.faName}
                                </strong>
                            </a>
                            {' محفوظ است. '}
                        </p>
                        <a href="https://barantm.com/landing/educational-website-design" target='_blank' rel='noopener' className="my-auto">
                            <p className="m-0">
                                {' این وبسایت توسط شرکت باران | '}
                                <a href="https://barantm.com/landing/educational-website-design">
                                    <strong className='text-bold'>
                                         طراحی سایت آموزشی
                                    </strong>
                                </a>
                                {'  طراحی و تولید شده است.'}
                            </p>
                        </a>

                    </div>

                </div>
               <div className="div-contact">
                        <div className={this.state.support ? "hidden-support open" : "hidden-support"}>
                            <div className="title-support">
                                <h2> تماس و پشتیبانی</h2>
                                <hr/>
                                <div className='text-center text-dark'>
                                    <div className='button-support d-flex flex-column align-items-center '>
                                        <div className='phone-btn'>
                                            {data.mobile.map((item) => (
                                                <NavLink
                                                    href={`tel: ${item?.value}`}
                                                    target="_blank" title={item?.label} rel="noopener noreferrer">
                                                    {item?.label}: {item?.value}
                                                    <Phone/>
                                                </NavLink>
                                            ))}
                                            <span className="top"></span>
                                            <span className="right"></span>
                                            <span className="bottom"></span>
                                            <span className="left"></span>
                                        </div>
                                        <div className='media-icon'>
                                            <div>
                                                <hr/>
                                                <h2> ما را در شبکات اجتماعی دنبال کنید.</h2>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <RenderMedia/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="btn-contact" onClick={() => {
                            this.handleSupport()
                        }} title="تماس و پشتیبانی" aria-label="تماس و پشتیبانی">
                            {this.state.support ?
                                <Close/>
                                :
                                <BiSupport/>
                            }
                        </button>
                    </div>
                <div className="copyright copyright-phone p-1 w-100 m-auto">
                    <p className="m-0">
                        کلیه حق و حقوق وبسایت برای {data.faName} محفوظ است
                    </p>
                </div>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        UI: state.UI
    }
}

export default connect(mapStateToProps)(Footer);
